<template>
  <v-menu
    offset-y
    left
  >
    <template #activator="{ on, attrs }">
      <v-btn
        small
        outlined
        elevation="0"
        class="sort-menu-button"
        v-bind="attrs"
        v-on="on"
      >
        <v-icon
          small
          left
        >
          mdi-swap-vertical
        </v-icon>
        {{ activeLabel }}
        <v-icon
          small
          right
        >
          {{ ascending ? 'mdi-arrow-up' : 'mdi-arrow-down' }}
        </v-icon>
      </v-btn>
    </template>
    <v-list dense>
      <v-list-item
        v-for="option in options"
        :key="option.value"
        @click="select(option.value)"
      >
        <v-list-item-title
          :class="{ 'primary--text font-weight-bold': option.value === value }"
        >
          {{ option.text }}
        </v-list-item-title>
        <v-list-item-icon
          v-if="option.value === value"
          class="my-2 ml-2"
        >
          <v-icon
            small
            color="primary"
          >
            {{ ascending ? 'mdi-arrow-up' : 'mdi-arrow-down' }}
          </v-icon>
        </v-list-item-icon>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
// One control for the whole sort concept: pick a field from the menu,
// pick the active field again to flip direction.
export default {
  name: 'SortMenuButton',
  props: {
    value: {
      type: String,
      required: true,
    },
    options: {
      type: Array,
      required: true,
    },
    ascending: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    activeLabel() {
      return this.options.find((option) => option.value === this.value)?.text || '';
    },
  },
  methods: {
    select(field) {
      if (field === this.value) {
        this.$emit('update:ascending', !this.ascending);
        return;
      }
      this.$emit('input', field);
    },
  },
};
</script>
